import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';
import PageHeader from 'components/common/PageHeader';

const ListHomeBanners = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/news/list`
        );
        console.log(response.data);
        setNews(response.data.data);
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      } finally {
        console.log('finally');
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveArticle = async (id, title) => {
    if (
      window.confirm(`Are you sure you want to delete this article: ${title}?`)
    ) {
      try {
        setError(null);
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/news/archive/id/${id}`
        );
        setNews(news.filter((event) => event.id !== id));
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      }
    }
  };

  return (
    <>
      {' '}
      <PageHeader
        title='Latest News'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope='col'>Title</th>
              <th scope='col'>Post Date</th>
              <th className='text-end' scope='col'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {news.map((item, index) => (
              <tr key={index}>
                <td>
                  <Link to={`/article/${item.id}`}>{item.title}</Link>
                </td>
                <td>{item.post_date}</td>
                <td className='text-end'>
                  <Link to={`/news/edit/${item.id}`}>
                    <ActionButton
                      icon='edit'
                      title='Edit'
                      variant='action'
                      className='p-0 me-2'
                    />
                  </Link>
                  <ActionButton
                    icon='trash-alt'
                    title='Delete'
                    variant='action'
                    className='p-0'
                    onClick={() => archiveArticle(item.id, item.title)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListHomeBanners;
